var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/modules/ui/events-calendar/events-calendar.html',
    '<div class="events-calendar">\n' +
    '    <div class="events-calendar__header">\n' +
    '        <button class="events-calendar__btn-prev" ng-click="prevMonth()" ng-if="monthDiff > 0">&#10094;</button>\n' +
    '        <span class="events-calendar__month-name">{{ monthName }}</span>\n' +
    '        <button class="events-calendar__btn-next" ng-click="nextMonth()" ng-if="monthDiff < maxMonths">&#10095;</button>\n' +
    '    </div>\n' +
    '    <div class="events-calendar__body">\n' +
    '        <table class="events-calendar__calendar">\n' +
    '            <thead class="events-calendar__weekday">\n' +
    '                <tr>\n' +
    '                    <th ng-repeat="dayName in days">{{ dayName }}</th>\n' +
    '                </tr>\n' +
    '            </thead>\n' +
    '            <tbody>\n' +
    '                <tr ng-repeat="week in monthArray track by $index">\n' +
    '                    <td ng-repeat="day in week track by $index">\n' +
    '                        <span class="events-calendar__day" ng-if="!isEventsOnDate(day)">{{ day }}</span>\n' +
    '                        <span class="events-calendar__day events-calendar__day--with-events"\n' +
    '                              ng-if="isEventsOnDate(day)">{{ day }}\n' +
    '                            <ul class="events-calendar__events">\n' +
    '                                <li ng-repeat="event in getEventsOnDate(day) track by $index">\n' +
    '                                    <a ng-href="{{ event.url }}" class="btn-link">{{ event.name }}</a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </span>\n' +
    '                    </td>\n' +
    '                </tr>\n' +
    '            </tbody>\n' +
    '        </table>\n' +
    '    </div>\n' +
    '</div>');
}]);

module.exports = "/modules/ui/events-calendar/events-calendar.html";